// extracted by mini-css-extract-plugin
module.exports = {"root":"_9dacdb","icon":"_570b7a","specialCurrency":"_4e4595"};